import ConstructionIcon from "@mui/icons-material/Construction";
import { AppBar, Box, Grid, Toolbar, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import SmartOceanLogo from "../../assets/img/smartOcean-black.png";
import { HeroBackground } from "../../components/ContentWrappers";
import LanguagePicker from "../../components/LanguagePicker";
import BoatAndBuoyAtSea from "../../assets/svg/BoatAndBuoyAtSea";
import { BACKGROUND_COLOR } from "../../styles/Theme";

export default function MaintenancePage() {
	const theme = useTheme();
	const { t } = useTranslation();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

	return (
		<Box minHeight="100vh" width="100vw" display="flex" bgcolor={BACKGROUND_COLOR}>
			<Box
				display="flex"
				flexDirection="column"
				justifyContent={isMobile ? "flex-start" : "space-between"}
				alignItems="center"
				bgcolor={BACKGROUND_COLOR}
				sx={{ width: { lg: "40%", xs: "100%" } }}
			>
				<AppBar position="static" elevation={0} sx={{ background: "none", mt: 4 }}>
					<Toolbar>
						<Grid container spacing={1} alignItems="center">
							<Grid item>
								<img src={SmartOceanLogo} alt="SmartOcean" height="30" />
							</Grid>
							<Grid item xs />
							{!isMobile && (
								<Grid item>
									<LanguagePicker sx={{ color: "primary" }} />
								</Grid>
							)}
						</Grid>
					</Toolbar>
				</AppBar>

				<Box
					display="flex"
					flexDirection="column"
					alignItems="center"
					textAlign="center"
					maxWidth="sm"
					py={6}
					px={isMobile ? 3 : 4}
					gap={2}
					flex={isMobile ? 1 : undefined}
				>
					<ConstructionIcon
						sx={{ fontSize: { xs: 64, sm: 80 }, color: "primary.main", mb: 1 }}
					/>
					<Typography variant="h4" fontWeight="bold" color="primary.main" lineHeight={1.2}>
						{t("maintenance.title")}
					</Typography>
					<Typography variant="h6" color="text.secondary" mt={1}>
						{t("maintenance.subtitle")}
					</Typography>
					<Typography
						variant="body1"
						color="text.secondary"
						mt={1}
						sx={{ maxWidth: 420 }}
					>
						{t("maintenance.description")}
					</Typography>
				</Box>

				<Box component="footer" sx={{ p: 2, bgcolor: BACKGROUND_COLOR, width: "100%", mb: 8 }}>
					<BoatAndBuoyAtSea showBuoy={true} />
					<Typography variant="body2" color="text.secondary" align="center" mt={1}>
						{"Copyright © "}
						<Typography
							variant="body2"
							component="a"
							color="inherit"
							href="https://smartocean.com/"
						>
							Smart Ocean AS
						</Typography>{" "}
						{new Date().getFullYear()}.
					</Typography>
				</Box>
			</Box>

			<Box sx={{ display: { lg: "block", xs: "none" }, width: "60%", p: 4, pl: 0 }}>
				<HeroBackground sx={{ borderRadius: 2, height: "100%" }} />
			</Box>
		</Box>
	);
}
